<template>
  <div class="gw_filter">
    <GwFilterBody
      ref="filterBody"
      :class="{ gw_loading: loading || filter_call.loading }"
      :asRow="asRow"
      :filterUrlPrefix="filterUrlPrefix"
      :filterConfig="l_filterConfig"
      :hasSaveBtn="hasSaveBtn"
      :hasClearBtn="hasClearBtn"
      :hasUrlUpdate="hasUrlUpdate"
      :allTags="allTags"
      @update:filter="handleUpdateFilter"
    >
      <template #filterbody="{ visibleFields, methods }">
        <slot
          name="filterbody"
          :visibleFields="visibleFields"
          :methods="methods"
        />
      </template>
    </GwFilterBody>
  </div>
</template>

<script>
import GwFilterBody from '@/components/DataTables/Filters/new/GwFilterBody'
import { getLocalFiltersConfigs } from '@/components/DataTables/Filters/new/filter_helpers'
import fetch_mix from '@/mixins/fetch_mix'

export default {
  name: 'GwFilter',
  components: {
    GwFilterBody,
  },
  mixins: [fetch_mix],
  props: {
    asRow: Boolean,

    filterConfig: Object,
    loading: Boolean,
    filterConfigKey: String,
    hasSaveBtn: { type: Boolean, default: true },
    hasClearBtn: { type: Boolean, default: true },
    filterUrlPrefix: { type: String, default: '' },
    hasUrlUpdate: { type: Boolean, default: true },
    endpoint: { default: () => 'poker/hand-history/filters/' },
    allTags: Array,
  },
  emits: ['update:filter'],
  data() {
    return {
      filter_call: {
        conf: {},
        loading: false,
        loaded: false,
        status: 0,
      },
      l_filterConfig: null,
    }
  },
  created() {
    this.initialize()
  },
  methods: {
    initialize() {
      if (this.filterConfigKey) {
        this.l_filterConfig = getLocalFiltersConfigs()[this.filterConfigKey]
        return
      }
      if (this.filterConfig) {
        this.l_filterConfig = this.filterConfig
        return
      }
      this.getData()
    },
    handleUpdateFilter({ filterParams, filter, initialUpdate }) {
      // console.log('handleUpdateFilter', { filter })
      const filterConf = {
        loaded: true,
        data: this.l_filterConfig,
        params: filterParams,
        filter,
        active: Object.keys(filterParams || {}).length > 0,
      }
      this.$emit('update:filter', filterConf)
      if (this.filterUrlPrefix) {
        // TODO new Filters
        // this is here if GwFilterBody reacts to watcher storeFilter (in reports flop we have this)
        // we should also better solve if we render 2+ filter components on the same page - so only one sets global state for the others perhaps
        // cos rn each computes its local state
        const storeFilter = this.$store.getters[this.filterUrlPrefix]
        if (
          !initialUpdate &&
          JSON.stringify(storeFilter?.params || {}) === JSON.stringify(filterConf?.params || {})
        ) {
          return
        }

        this.$store.commit('filters_set', {
          key: this.filterUrlPrefix,
          value: filterConf,
        })
      }
    },
    // saveFilter() {
    //   console.log('handleSaveFilter')
    // },
    async getData() {
      const { endpoint } = this
      this.filter_call.conf = {
        endpoint,
        gwCacheId: endpoint,
        apiVersion: 'v2',
        waitForCache: true,
        gwCacheAdd: true,
        gwCacheInvalidate: true,
      }
      const { data, error } = await this.fch_getData(this.filter_call)
      if (error) {
        this.$store.dispatch('messages', {
          type: 'error',
          status: 'err_message',
          statusMessages: {
            _err_message: {
              i18n: `messages.filter_fetch_failed_status_xxx`,
              i18nParams: { status: error?.response?.status || 'unknown' },
            },
          },
        })
        return
      }
      this.l_filterConfig = data
    },
  },
  watch: {
    filterConfig: {
      immediate: false,
      handler: 'initialize',
    },
  },
}
</script>
<style lang="scss" scoped>
.gw_filter_body {
  display: flex;
  flex-direction: column;
  &_row {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
}
</style>
